import { CartFragment as CartFragmentType } from '@/features/graphql/generated/graphql'
import { useCartKeyContext } from '@/features/pos/components/Cart/contexts/CartKey'
import { CartFragment } from '@/features/pos/components/Cart/fragments/cart'
import { useFragment } from '@apollo/client'

export const useCartCache = (): CartFragmentType | undefined => {
    const { cartKey } = useCartKeyContext()

    const { data, complete } = useFragment({
        fragment: CartFragment,
        fragmentName: 'Cart',
        from: { __typename: 'Cart', key: cartKey ?? '' },
    })

    return complete ? data : undefined
}
